var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadgeYellowBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 64,
    viewBox: "0 0 90 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4016_10361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 8L82 0V64L90 56V8Z",
    fill: "#DC7800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.999C0 45.1997 8.55388 56 19.0092 56H90V8H19.0092C8.55388 8 0 18.8003 0 31.999Z",
    fill: "#FFC800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4016_10361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.0002,
    height: 64,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4016_10361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2069,
    height: 24,
    fill: "white",
    transform: "translate(36 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeYellowBg);
export default __webpack_public_path__ + "static/media/badge-yellow-bg.03a7cba0f94da63f518ad4d80815d662.svg";
export { ForwardRef as ReactComponent };